module.exports = "#uploader {\n    padding: 0px 30px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/agora/components/product-data/custom-topics/custom-topic-subtopic-add/custom-topic-subtopic-add.component.css
// module id = ./src/app/agora/components/product-data/custom-topics/custom-topic-subtopic-add/custom-topic-subtopic-add.component.css
// module chunks = main